import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import DateNavigation from "components/DateNavigation";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "top",
    },
  },
};

const BarChartDateArrowSelector = ({
  dataToShow, title, selectedDate, setSelectedDate, minDate, maxDate, interval
}) => {
  let dataSets = [];

  Object.keys(dataToShow).forEach((data) => {
    if (data !== "labels") {
      if (Array.isArray(dataToShow[data])) {
        dataSets = dataToShow[data];
      } else {
        dataSets.push(dataToShow[data]);
      }
    }
  });

  const data = {
    labels: dataToShow.labels,
    datasets: dataSets,
  };
 
  return (
    <DateNavigation
      title={title}
      selectedDate={selectedDate}
      setSelectedDate={setSelectedDate}
      minDate={minDate}
      maxDate={maxDate}
      interval={interval}
    >
      <Bar
        data={data}
        options={options}
        style={{ height: "100%" }}

      />
    </DateNavigation>
  );
}

export default BarChartDateArrowSelector